<template>
  <SUserLayout
    sidebarTitle="settings.title"
    sidebarIcon="mdi-cog"
    :sidebarItems="items"
  >
    <div class="setting-page-container__content d-flex justify-content-center">
      <RouterView />
    </div>
  </SUserLayout>
</template>

<script lang="ts">
export default {
  name: 'SettingsPage',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import appConfig from '@/appConfig';
import SUserLayout from '@slg/web-customer-shared/src/components/layouts/userLayout/SUserLayout.vue';
import { useI18n } from '@/composables';

const { t } = useI18n();

const items = computed(() => {
  const base = [
    {
      name: t('settings.profile'),
      route: 'profile',
    },
  ];

  base.push({
    name: t('settings.security'),
    route: 'security',
  });

  if (appConfig.isNightCardsSupport) {
    base.push({
      name: t('nightRiderLink.settingsMenuSubtitle'),
      route: 'night-card',
    });
  }

  return base;
});
</script>
